import { Component, Input, Output, EventEmitter, SimpleChange, ViewChild, ElementRef, Renderer2 } from '@angular/core';
import * as _ from "lodash";
import { LogisticsInventoryCurrentBalances } from 'src/app/services/service/DataProviders/LogisticsInventoryCurrentBalances';
import { ProductionShopFloorWorkOrders } from 'src/app/services/service/DataProviders/ProductionShopFloorWorkOrders';
import { ProductionTechnologiesRecipes } from 'src/app/services/service/DataProviders/ProductionTechnologiesRecipes';
import { RecipeTree } from '../../subproducts/subproducts-tree/recipe-tree';
import { PoTree } from '../po-tree/potree/po-tree';

@Component({
  selector: 'po-analysis',
  templateUrl: './po-analysis.component.html',
  styleUrls: ['./po-analysis.component.scss'],
})
export class PoAnalisysComponent {

  @Input() wo: any[] = [];
  @Input() recepiesToProcess;
  @Input() parent: any;

  public po = null;
  // public poTreeForView: any = [];
  public poListForView: any = {};
  public poTree = null;

  public recipeTree: any = [];
  public recipeTreeForView: any = [];

  constructor(private woService: ProductionShopFloorWorkOrders,
    private recipeService: ProductionTechnologiesRecipes,
    private availabilityService: LogisticsInventoryCurrentBalances,
    ) { }

  ngOnChanges(sc: SimpleChange) {
    if (_.has(sc, 'wo.currentValue') && Object.keys(sc['wo'].currentValue).length > 0) {
      this.po = sc['wo'].currentValue;
      this.initTree();
    }
  }

  async initTree() {
    this.poTree = new PoTree(this.woService);
    const masterNode = await this.poTree.buildTree(this.po);
    const maxLevel = await this.poTree.getMaxLevel();
    // this.poTreeForView = [this.buildPoTreeForFE(masterNode, this.poTree)];

    await this.addRecipesAndBuildTree();

    await this.makeAnalisys();
  }

  async makeAnalisys() {
    //водещото са технологиите
    // console.log(this.poTree)
    // console.log(this.recipeTree)

    const tehForAnalisys = {};
    for(let i = 0; i < this.recipeTree.length; i++) {
      const recipeTree = this.recipeTree[i];
      for(let level = 0 ; level < recipeTree.maxLevel; level++) {
        const recipes = recipeTree.getNodesOnLevel(level);
        for(let k = 0; k < recipes.length; k++) {
          const recipe = recipes[k];
          const rProductId = recipe.product.Id;
          const predecessor = _.get(recipeTree.getPredecessor(recipe), '[0].product.Id', 'null');
          const identity = [
            level,
            rProductId,
            predecessor
          ].join('/');

          if(!_.isNull(recipe.defaultTechnology)) {
            tehForAnalisys[identity] = {
              recipe,
              product: recipe.product,
              ingredients: recipe.defaultTechnologyIngredients,
              level
            };
          }

        }
      }
    }

    const poForAnalisys = {};
    for(let level = 0 ; level <= this.poTree.maxLevel; level++) {
      const pos = this.poTree.getNodesOnLevel(level);
      console.log(pos);
      for(let k = 0; k < pos.length; k++) {
        const po = pos[k];

        //това работи само ако са отделни ПН за всеки продукт
        const predecessors = this.poTree.getPredecessor(po);
        const predecessor = _.get(predecessors, '[0].items[0].Product.Id', 'null');

        for(let i = 0; i < po.itemsWithIngredients.length; i ++){
          const item = po.itemsWithIngredients[i]['item'];
          const ingredients = po.itemsWithIngredients[i]['ingredients'];
          const iProductId = item.Product.Id;

          const identity = [
            level,
            iProductId,
            predecessor
          ].join('/');
          poForAnalisys[identity] = {
            po,
            product: item.Product,
            ingredients: ingredients,
            level
          };
        }
      }
    }

    console.log('tehForAnalisys', tehForAnalisys);
    console.log('poForAnalisys', poForAnalisys);

    this.poListForView = {};
    for(let idx in tehForAnalisys) {
      if(_.has(poForAnalisys, idx)) {
        //има пн за тази технология
        //трябва да се анализират съставките и продукта

        this.poListForView[idx]  = {
          teh: tehForAnalisys[idx],
          po: poForAnalisys[idx],
          void: false
        };

        this.compare(this.poListForView[idx].po, this.poListForView[idx].teh);

      }
      else {
        //няма Пн за тази технология
        this.poListForView[idx]  = {
          teh: tehForAnalisys[idx],
          po: this.tehToPo(tehForAnalisys[idx]),
          void: false
        };
      }
    }

    for(let idx in poForAnalisys) {
      if(!_.has(tehForAnalisys, idx)) {
        //това пн трябва да се анулира
        this.poListForView[idx]  = {
          teh: null,
          po: poForAnalisys[idx],
          void: true
        };
      }
    }

    // console.log(this.poTreeForView)
    console.log('result', this.poListForView)
  }

  private tehToPo(teh) {
    return {
      po: {
        itemsWithIngredients: [{
          item: {
            ProducedQuantity: {
              Unit: teh.product.MeasurementUnit.Code,
              Value: 1
            },
            Product: teh.product,
            LineOrd: 10,
          },
          // ingredients: [],
          ingredients: _.map(teh.ingredients, (i, idx) => { return {
              UsedQuantity: i.UsageQuantity,
              Material: i.Material,
              LineOrd: i.LineOrd,
            }
          })
        }]
      }
    }
  }

  private compare(po, teh) {
    const poItem = po.po.itemsWithIngredients[0].item;
    const poItemIngredients = po.po.itemsWithIngredients[0].ingredients;

    if(poItem.Product.Id === teh.product.Id) {
      po['_found'] = true;
      poItem['_found'] = true;
      teh['_found'] = true;

      if(poItem.ProducedQuantity.Unit != teh.recipe.measurementUnit.Code ||
        poItem.ProducedQuantity.Value != teh.recipe.quantity) {
          poItem['_quantityChanged'] = true;
          poItem['_quantityChange'] = {
            fromQuantity: poItem.ProducedQuantity.Value,
            fromUnit: poItem.ProducedQuantity.Unit,
            toQuantity: teh.recipe.quantity,
            toUnit: teh.recipe.measurementUnit.Code,
          };
        }
        else {
          poItem['_quantityChanged'] = false;
        }
    }


    for(let j = 0; j < poItemIngredients.length; j++) {
      const poIng = poItemIngredients[j];

      for(let i = 0; i < teh.ingredients.length; i++) {
        const tehIng = teh.ingredients[i];

        const tehIngUsed = _.get(tehIng, '_found', false);
        if(tehIngUsed) {
          continue;
        }

        if(poIng.Material.Id === tehIng.Material.Id) {
          poIng['_found'] = true;
          tehIng['_found'] = true;

          // console.log('tehIng', tehIng)

          tehIng['_realQuantity'] = _.round(tehIng.UsageQuantity.Value * teh.recipe.quantity, 3);

          if((poIng.UsedQuantity.Unit != tehIng.UsageQuantity.Unit ||
            poIng.UsedQuantity.Value != tehIng['_realQuantity'])
            //има разлика в закръгленията така ги фиксвам защото не знам от къде идва
            && Math.abs(_.round(poIng.UsedQuantity.Value - tehIng['_realQuantity'], 3)) > 0.001
            ) {
              poIng['_quantityChanged'] = true;
              poIng['_quantityChange'] = {
                fromQuantity: poIng.UsedQuantity.Value,
                fromUnit: poIng.UsedQuantity.Unit,
                toQuantity: tehIng['_realQuantity'],
                toUnit: tehIng.UsageQuantity.Unit,
              };
            }
            else {
              poIng['_quantityChanged'] = false;
            }
          break;
        }
      }
    }

    for(let i = 0; i < teh.ingredients.length; i++) {
      // завъртам ги още веднъж да вида дали някой не е изпуснат
      const tehIng = teh.ingredients[i];
      if(!tehIng['_found']) {
        poItemIngredients.push({
          UsedQuantity: tehIng.UsageQuantity,
          LineOrd: tehIng.LineOrd,
          Material: tehIng.Material,
          _quantityChanged: true,
        })
      }

    }
  }

  private buildPoTreeForFE(node, poTree) {
    return {
      node,
      children: poTree.getSuccessors(node).map((n) => this.buildPoTreeForFE(
        n,
        poTree
      ))
    }
  }

  async addRecipesAndBuildTree() {
    this.recipeTree = [];
    this.recipeTreeForView = [];
    for (let i = 0; i < this.recepiesToProcess.length; i++) {
      let recipe = this.recepiesToProcess[i].Recipe;
      let quantity = _.get(
        this.recepiesToProcess[i],
        "ProducedQuantityBase.Value"
      );

      this.recipeTree[i] = new RecipeTree(this.recipeService, this.availabilityService);
      await this.recipeTree[i].init(recipe.Product, quantity);
    }

    this.buildRecipeTreeForView();
  }

  buildRecipeTreeForView() {
    for (let i = 0; i < this.recipeTree.length; i++) {
      let tree = this.recipeTree[i];
      let maxLevel = tree.maxLevel;
      let rootNode = tree.getNodesOnLevel(0)[0];

      this.recipeTreeForView[i] = this.buildRecipeTree(rootNode, maxLevel);
    }
  }

  buildRecipeTree(n, maxLevel) {
    let self = this;
    let node = {
      node: n,
      children: [],
    };

    if (n.level > maxLevel) {
      return [];
    }

    let tree = n.tree.tree;
    let level = n.level + 1;

    tree.forEachLinkedNode(n, function (linkedNode, link) {
      if (linkedNode.id.level == level) {
        node.children.push(self.buildRecipeTree(linkedNode.id, maxLevel));
      }
    });

    return node;
  }

  getChildrens = (node) => node.children || [];

}
